<template>
  <article>
    <!-- pc -->
    <div class="center">
      <ul class="content">
        <li>
          <h2><span>我们的愿景</span> Our Vision</h2>
          <h3 class="h3">做更有思想的工程咨询专家</h3>
          <p>To be a more thoughtful expert of</p>
          <p>engineering consultation</p>
        </li>
        <li>
          <h2><span>我们的使命</span> Our Mission</h2>
          <h3>为客户提供全方位高品质的服务</h3>
          <h3 class="h3">为公司员工创造共赢的发展平台</h3>
          <p>To provide customers with all-round</p>
          <p>services of high quality and to create</p>
          <p>a win-win development platform for</p>
          <p>employees</p>
        </li>
        <li>
          <h2><span>我们的核心价值观</span> Our Core Value</h2>
          <h3 class="h3">多元、专业、创新、协作</h3>
          <p>Diversification</p>
          <p>professionalism,innovation</p>
          <p>and collaboration</p>
        </li>
      </ul>
    </div>
    <!-- 移动 -->
    <div class="center1">
      <ul class="content1">
        <li>
          <h2>
            <span>我们的愿景</span><br />
            Our Vision
          </h2>
          <h3>做更有思想的工程<br />咨询专家</h3>
          <p>To be a more </p>
          <p>thoughtful expert </p>
          <p>of engineering</p>
          <p>consultation</p>
        </li>
        <li>
          <h2>
            <span>我们的使命</span><br />
            Our Mission
          </h2>
          <h3>为客户提供全方位<br />高品质的服务</h3>
          <h3>为公司员工创造共<br />赢的发展平台</h3>
          <p>To provide customers</p>
          <p>with all-round services</p>
          <p>of high quality and</p>
          <p>to create a win-win development</p>
          <p>platform for employees</p>
        </li>
        <li>
          <h2>
            <span>我们的核心价值观</span><br />
            Our Core Value
          </h2>
          <h3>多元、专业、创新、<br />协作</h3>
          <p>Diversification</p>
          <p>professionalism</p>
          <p>innovation</p>
          <p>and collaboration</p>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  name: "wx-article",
  data() {
    return {};
  },
};
</script>
<style scoped lang='less'>
@co3: rgba(184, 36, 60);
@time: 1s;
@delay: 0.1s;
article {
  width: 100%;
  // height: 420px;
}
.center {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.center1 {
  display: none;
}
.center .content {
  width: 1500px;
  margin: 0 auto;
  height: 100%;
  // padding: 0 135px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  li {
    // border: 1px solid red;
    padding: 30px 0;
    // padding-left: 50px;
    width: 30%;
    display: flex;
    flex-flow: column;
    &:nth-last-child(1) {
      position: relative;
      left: 40px;
    }
  }
}

.center .content li h2 {
  font-size: 24px;
  padding: 10px 0;
  font-weight: 600;
  width: 80px;
  white-space: nowrap;
  // border-bottom: 2px solid @co;
  margin-bottom: 24px;
  color: @baseTitle;
  color: #333333;
}
.center .content li h2 span {
  color: #333333;
  /* letter-spacing: 2px; */
}
.h3 {
  margin-bottom: 10px;
}
.center .content li h3 {
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  color: #666666;
}
.center .content li p {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  white-space: nowrap;
  @color: @baseCon;
  color: #333333;
}
@media (max-width: 1000px) {
  article {
    height: 250px;
  }
  .center {
    display: none;
  }
  .center1 {
    display: block;
    margin: 50px 0;
  }
  .center1 .content1 {
    width: 100%;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    li {
      width: 33.3333333333%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .center1 .content1 li h2 {
    font-size: 10px;
    padding: 8px 0;
    font-weight: 600;
    white-space: nowrap;
    // margin-bottom: 8px;
    color: @baseTitle;
    color: #333333;
  }
  .center1 .content1 li h2 span {
    color: #333333;
  }

  .center1 .content1 li h3 {
    font-size: 8px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 4px;
    color: #666666;
  }
  .center1 .content1 li p {
    font-size: 8px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    @color: @baseCon;
    color: #333333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/our_server/article.vue